import React from "react";
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaWhatsapp,FaMapMarkerAlt,FaEnvelope,FaPhoneAlt } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Working Hours</h3>
          <p>Monday - Friday: 8:00 AM - 5:00 PM</p>
          <p>Saturday: 8:00 AM - 3:00 PM</p>
          <p>Sunday & Public Holiday: Closed</p>
        </div>

        {/* Contact + Social */}
        <div className="footer-section">
          <h3>Contact Us</h3>

          <div className="contact-item">
            <FaMapMarkerAlt className="contact-icon" />
            <span>Head Office:  No. 60 Stormvoel road,<br/> Eastlynne, Gauteng, 0039</span>
          </div>
          <div className="contact-item">
            <FaMapMarkerAlt className="contact-icon" />
            <span>Opposite Mamelodi Ext Di16 Shoprite<br/> Mamelodi East, Gauteng, 0122</span>
          </div>
          
          <div className="contact-item">
            <FaMapMarkerAlt className="contact-icon" />
            <span> No. 20943, Buffer Pearl, Rethabile,<br/> Mamelodi East, Gauteng, 0122</span>
          </div>

          <div className="contact-item">
            <FaPhoneAlt className="contact-icon" />
            <span>082 721 2947 | 067 007 5707</span>
          </div>

          <div className="contact-item">
            <FaEnvelope className="contact-icon" />
            <span>madithapajerry2@gmail.com</span>
          </div>


          <div className="social-links">
            <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/jerrymadithapafunerals?igsh=MTM3YXZ1NnZia2s3cw==" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://wa.me/+27827212947" target="_blank" rel="noreferrer">
              <FaWhatsapp />
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Jerry Madithapa Funerals. All Rights Reserved.
      </div>
    </footer>
  );
}
